<template>
  <Box ref="container" class="bg-white/90 p-5" rounded="lg">
    <div class="flex items-center justify-between">
      <h4
        class="font-Kontesa text-[28px] font-bold uppercase leading-none tracking-tight text-navy"
      >
        Impact family
      </h4>

      <Box
        v-if="!hideHelp"
        class="h-10 w-10 bg-[#F1EBFF]"
        rounded="full"
        border="lg"
      >
        <button
          type="button"
          class="flex h-full w-full items-center justify-center"
          @click="playVideo()"
        >
          <IconsQuestionMark />
        </button>
        <VideoPlayerModal id="481769494" ref="video" />
      </Box>
    </div>

    <div class="my-5 border-b border-dashed border-navy" />

    <ProfileImpactStat
      ref="family"
      type="family"
      :amount="size"
      :previous-amount="previousSize"
      @animation-end="$emit('animation-end')"
    >
      <DialogRoot v-model:open="open">
        <DialogTrigger class="h-10 w-10 shrink-0">
          <Box
            rounded="full"
            border="lg"
            class="flex h-full w-full items-center justify-center"
          >
            <IconsEyeOpen class="h-4 w-4" />
          </Box>
        </DialogTrigger>

        <ImpactFamilyModal v-if="open" :member-id="memberId" />
      </DialogRoot>
    </ProfileImpactStat>

    <template v-if="referralCode">
      <div class="my-5 border-b border-dashed border-navy" />

      <ProfileImpactCopyReferralButton :referral-code="referralCode" />
    </template>
  </Box>
</template>

<script setup lang="ts">
import ProfileImpactStat from "@/components/Profile/Impact/Stat.vue";
import type VideoPlayerModal from "~/components/VideoPlayer/Modal.vue";

defineProps<{
  referralCode?: string;
  size: number;
  previousSize?: number;
  hideHelp?: boolean;
  memberId: number;
}>();
defineEmits<{
  (e: "animation-end"): void;
}>();

const open = ref(false);

const video = ref<InstanceType<typeof VideoPlayerModal> | null>(null);
function playVideo() {
  video.value?.play();
}

const container = ref<HTMLElement | null>(null);
const family = ref<InstanceType<typeof ProfileImpactStat> | null>(null);

function playAnimation() {
  family.value?.playAnimation();
}

defineExpose({ playAnimation });
</script>
